import Header from "../header";
import SuperAdmin from "./superadmin";
import Footer from "../footer";

function Main() {
  return (
    <div>
      <Header />
      <SuperAdmin />
      <Footer />
    </div>
  );
}

export default Main;
